import { render, staticRenderFns } from "./TentativeSubmit.vue?vue&type=template&id=d97bf7c8&"
import script from "./TentativeSubmit.vue?vue&type=script&lang=js&"
export * from "./TentativeSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports